import fetch from '../utilities/fetchAxios'

export const getAppConfig = async () => {
  const method = 'GET'
  const path = '/info/v1/appconfig'
  return fetch(method, path)
}
